
import salutations from '~/static/salutations.json'

export default {
  data() {
    return {
      salutations,
      isLoading: false,
      form: {
        salutation: '',
        company: '',
        firstname: '',
        lastname: '',
        phone: '+41',
        email: '',
        street: '',
        postcode: '',
        city: '',
        country: '',
        type: '',
        // salutation: 'Herr',
        // company: 'novu GmbH',
        // firstname: 'Max',
        // lastname: 'Mustermann',
        // phone: '+41 123456789',
        // email: 'max@novu.ch',
        // street: 'Sulgenrain 12',
        // postcode: '3007',
        // city: 'Bern',
        // country: 'CH',
        // type: 'private',
      },
    }
  },

  head() {
    return {
      title: 'Registrieren',
    }
  },

  methods: {
    register() {
      if (this.isLoading) {
        return
      }

      this.isLoading = true

      this.$axios
        .$post('/auth/register', this.form)
        .then(() => {
          this.$refs.form.reset()

          this.$toast.success(
            'Danke für die Registrierung. In Kürze erhalten Sie eine E-Mail von uns, um Ihr Passwort zu setzen.'
          )

          this.form = {
            salutation: '',
            company: '',
            firstname: '',
            lastname: '',
            phone: '+41',
            email: '',
            street: '',
            postcode: '',
            city: '',
            country: '',
            type: '',
          }
        })
        .catch(({ response }) => {
          this.$toast.error(
            'Etwas ist schief gelaufen. Bitte versuchen Sie es später erneut'
          )
          this.$refs.form.setErrors(response.data.errors)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  },
}
